import { gql } from "@apollo/client";

export const CREATE_BOOKING = gql`
    mutation CreateBooking($input: CreateBookingInput) {
        createBooking(input: $input) {
            id
            sourceBookingId
            sourceVehicleId
            vmhId
            shId
            oemId
            profileId
            userId
            scheduledReleasedAt
            scheduledReturnedAt
            actualReleasedAt
            actualReturnedAt
            type
            status
            usageType
            prepareStatus
            releasingAddress
            returningAddress
            releasedTo
            releasedBy
            returnedBy
            closedBy
            deniedNotes
            serviceBookingPurpose
            specialRequestRemark
            vehicleConditionalSnapshots {
                id
                type
                fuelLevel
                isDamaged
                odometer
                damagedNotes
                bookingId
            }
        }
    }
`;

export const UPDATE_BOOKING = gql`
    mutation UpdateBooking($input: UpdateBookingInput) {
        updateBooking(input: $input) {
            id
        }
    }
`;
